<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="$t('message.terms.title')"
          :icon="''">
        </header-view>
      </b-col>
    </b-row>


    <b-row class="mt-4">
      <b-col>
        <ul class="list-unstyled">
          <li>Nutzungsbedingungen digitaler Vertragsmanager</li>

          <li><a class="ref" href="#first">§ 1. Geltungsbereich</a></li>

          <li><a class="ref" href="#second">§ 2. Registrierung durch den Nutzer</a></li>

          <li><a class="ref" href="#third">§ 3. Leistungen digitaler Vertragsmanager</a></li>

          <li><a class="ref" href="#fourth">§ 4. Pflichten des Nutzers</a></li>

          <li><a class="ref" href="#fifth">§ 5. Haftung</a></li>

          <li><a class="ref" href="#sixth">§ 6. Urheberrechte</a></li>

          <li><a class="ref" href="#seventh">§ 7. Schlussbestimmungen</a></li>
        </ul>

        <h1 id="first">§ 1. Geltungsbereich</h1>

        <p>(1) Diese Nutzungsbedingungen
          sind Allgemeine Geschäftsbedingungen (im Folgenden “AGB”) und gelten für alle Nutzer
          der Webseite <a href="http://www.meine-vertraege.net">www.meine-vertraege.net</a> (im Folgenden “digitaler
          Vertragsmanager”). Maßgebend
          ist die jeweils bei Registrierung (§ 2) gültige Fassung der AGB.</p>

        <p>(2) Betreiber des digitalen
          Vertragsmanagers ist CodeCamp:N GmbH, Solgerstr. 18,
          90429 Nürnberg (im Folgenden „CodeCamp:N“).

        </p>

        <p>(3) Nutzer sind
          natürliche Personen, die nach § 2 registriert wurden.

        </p>

        <p>(4) Abweichende
          Bedingungen des Nutzers akzeptieren wir, also CodeCamp:N,
          nicht. Dies gilt auch, wenn wir der Einbeziehung nicht ausdrücklich
          widersprechen.
        </p>

        <p>(5) Die Dienstleistung
          der CodeCamp:N im Rahmen des digitalen
          Vertragsmanagers stellt eine Geschäftsbesorgung nach §§ 675, 611 BGB dar.
        </p>

        <h1 id="second">§ 2. Registrierung durch den Nutzer
        </h1>

        <p>(1) Nutzer des digitalen
          Vertragsmanagers können ausschließlich nur solche sein, die zugleich eine versicherte Personen der
          Bestattungsvorsorgeversicherung
          der NÜRNBERGER Lebensversicherung AG sind. Soweit der Versicherungsnehmer und
          die versicherte Person sich unterscheiden, ist ausschließlich die versicherte
          Person berechtigt, die Registrierung durchzuführen.</p>

        <p>(2) Der Nutzer
          registriert sich nach Abschluss der Bestattungsvorsorgeversicherung unter
          Angabe von Vor-, Nachname, E-Mail-Adresse und Versicherungsnummer bei der
          NÜRNBERGER Lebensversicherung AG erstmalig auf der Internetseite des digitalen
          Vertragsmanagers unter <a href="http://www.meine-vertraege.net">www.meine-vertraege.net</a>. Daraufhin prüft
          CodeCamp:N,
          ob der Nutzer über eine Bestattungsvorsorgeversicherung bei der NÜRNBERGER
          Lebensversicherung AG verfügt. Wenn dem so ist, wird CodeCamp:N
          die Registrierung bestätigen und den Nutzer legitimieren. Andernfalls wird der
          Nutzer durch CodeCamp:N darauf hingewiesen, dass eine
          Legitimierung fehlgeschlagen ist und sein Konto gelöscht wird. Ein wirksamer
          Vertrag zwischen dem Nutzer und CodeCamp:N über die
          Nutzung des digitalen Vertragsmanagers kommt nur dann zustande, wenn CodeCamp:N
          die Registrierung bestätigt.</p>

        <h1 id="third">§ 3. Leistungen digitaler Vertragsmanager
        </h1>

        <p>(1) Der digitale
          Vertragsmanager ermöglicht die Erfassung von Verträgen des Nutzers unter <a
            href="http://www.meine-vertraege.net">www.meine-vertraege.net</a><, indem Informationen über den jeweiligen
          Vertrag durch den Nutzer gespeichert werden können. Diese Informationen über die erfassten
          Verträge können vom Nutzer jederzeit eingesehen und geändert werden (Vertragsverwaltung).
          <b>Vertragsdaten beim jeweiligen
            Vertragspartner des Nutzers können über den digitalen Vertragsmanager nicht
            geändert werden.</b></p>

        <p>(2) Des Weiteren kann der
          Nutzer seine Wohnadresse/n erfassen und verwalten (Adressverwaltung). Jeder
          gespeicherte Vertrag nach § 3 Abs. 1 kann somit einer Wohnadresse des Nutzers zugeordnet
          werden.
        </p>

        <p>(3) Im Übrigen kann der
          Nutzer eine oder mehrere Kontaktpersonen unter Angabe von Namen, Anschriften
          und E-Mail-Adressen speichern. Die vom Nutzer jeweils bestimmte Kontaktpersonen
          erhalten nach dem Versterben des Nutzers ein Leserecht auf die gespeicherten Verträge
          des Nutzers, soweit der Nutzer der jeweiligen Kontaktperson einzelne Verträge
          zugewiesen hat. Der Nutzer hat die Möglichkeit, das Leserecht der Kontaktperson
          auf bestimmte Verträge zu beschränken.
        </p>

        <p>(4) Wenn CodeCamp:N über die Kontaktperson oder auf andere Weise die
          Meldung erhält, dass der Nutzer verstorben ist, so wird CodeCamp:N daraufhin
          die Vertragspartner des Nutzers, der jeweils gespeicherten Verträge über den
          Tod des Nutzers informieren. Die Meldung über den Tod des Nutzers hat in
          nachweisbarer Form zu erfolgen, d. h. der Nachweis gilt für CodeCamp:N
          als erbracht, wenn CodeCamp:N das Original oder eine Kopie einer Sterbeurkunde
          erhält und diese verifizieren konnte. Außerdem werden die Informationen über
          die gespeicherten Verträge des Nutzers im digitalen Vertragsmanager nach dem
          Tod des Nutzers eingefroren, d. h. die Informationen können von niemandem mehr (auch
          nicht von einer leseberechtigten Kontaktperson) verändert werden.</p>

        <p>(5) Erben des
          verstorbenen Nutzers, die sich bei CodeCamp:N melden
          und sich als Erben legitimieren können (z.B. durch Vorlage eines Erbscheins),
          erhalten zusätzlich ein Leserecht auf alle vom Nutzer gespeicherten Verträge,
          soweit sie nicht bereits als Kontaktperson über ein Leserecht verfügen.
        </p>

        <p>(6) <b>Die Information, die von CodeCamp:N gegenüber
          dem Vertragspartner des Nutzers erfolgt, ist lediglich eine Information und
          führt zu keinerlei rechtlichen Wirkung wie etwa einer Vertragsänderung oder
          Vertragskündigung.</b> Die Information erfolgt gemäß den Vorgaben des
          Nutzers (insbesondere Adressat der Information). CodeCamp:N
          prüft diese Vorgaben nicht auf ihre Richtigkeit.
        </p>

        <h1 id="fourth">§ 4. Pflichten des Nutzers
        </h1>

        <p>(1) Der Nutzer ist
          verpflichtet, vollständige und richtige Informationen und Daten im digitalen
          Vertragsmanager einzugeben. Sollte der Nutzer vorsätzlich falsche Angaben
          machen, behält sich CodeCamp:N vor, den Nutzer von der
          Nutzung des digitalen Vertragsmanagers auszuschließen und/oder ggf. Schadensersatz
          zu verlangen.
        </p>

        <p>(2) CodeCamp:N
          ist nicht verpflichtet, die Informationen des Nutzers im digitalen
          Vertragsmanagers auf Ihre Richtigkeit und Vollständigkeit zu prüfen. Außerdem
          übernimmt CodeCamp:N keine Verpflichtung diese
          Information zu aktualisieren. Die Pflicht zur Pflege dieser Informationen,
          insbesondere jedoch nicht abschließend die Prüfung auf die Richtigkeit,
          Vollständigkeit sowie die Aktualität der Informationen, obliegt dem Nutzer.
        </p>

        <h1 id="fifth">§ 5. Haftung</h1>

        <p>(1) CodeCamp:N
          haftet nicht für die Richtigkeit und Vollständigkeit der vom Nutzer eingegebenen
          Informationen und Daten. CodeCamp:N haftet dem Nutzer
          gegenüber nur in Fällen vertraglicher und außervertraglicher Pflichtverletzung
          soweit Vorsatz und grobe Fahrlässigkeit vorliegt.
        </p>

        <p>(2) In sonstigen Fällen
          haftet CodeCamp:N– soweit in Abs. 3 nicht abweichend
          geregelt – nur bei Verletzung einer Vertragspflicht, deren Erfüllung die
          ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf
          deren Einhaltung der Nutzer regelmäßig vertrauen darf (so genannte
          Kardinalpflicht), und zwar beschränkt auf den Ersatz des vorhersehbaren und
          typischen Schadens. In allen übrigen Fällen ist die Haftung vorbehaltlich der
          Regelung in Abs. 3 ausgeschlossen.
        </p>

        <p>(3) Die Nutzung des
          digitalen Vertragsmanagers im Wege des Internets erfolgt auf eigene Gefahr des
          Nutzers. CodeCamp:N haftet nicht für den technisch
          bedingten Ausfall des Internets bzw. des Zugangs zum Internet.
        </p>

        <p>(4) CodeCamp:N
          übernimmt die Haftung für die Inhalte seiner Webseite gemäß den gesetzlichen
          Bestimmungen. Eine Gewähr für Richtigkeit und Vollständigkeit der Information
          wird nicht übernommen. Verweise und Links auf Webseiten Dritter bedeuten nicht,
          dass sich CodeCamp:N die hinter dem Verweis oder Link
          liegenden Inhalte zu eigen macht. Die Inhalte begründen keine Verantwortung von
          CodeCamp:N für die dort bereit gehaltenen Daten und
          Informationen. CodeCamp:N hat keinen Einfluss auf die
          hinter dem Link liegenden Inhalte. Für rechtswidrige, fehlerhafte oder
          unvollständige Inhalte und für Schäden, die aufgrund der Nutzung von einem
          hinter dem Link liegenden Inhalt verursacht worden sind, haftet CodeCamp:N daher nicht.</p>

        <h1 id="sixth">§ 6. Urheberrechte</h1>

        <p>(1) Der digitale
          Vertragsmanager beinhaltet Daten und Informationen aller Art, die marken-
          und/oder urheberrechtlich zugunsten CodeCamp:N oder im
          Einzelfall auch zugunsten Dritter geschützt sind. Es ist daher nicht gestattet,
          den digitalen Vertragsmanager als Webseite im Ganzen oder einzelne Teile davon
          herunterzuladen, zu vervielfältigen und/oder zu verbreiten. Gestattet ist die
          technisch bedingte Vervielfältigung zum Zwecke des Browsing, soweit diese
          Handlung keinen wirtschaftlichen Zwecken dient, sowie die dauerhafte
          Vervielfältigung für den eigenen Gebrauch.
        </p>

        <p>(2) Eine Verwendung der
          Bilder, Filme und Texte des digitalen Vertragsmanagers ist ohne ausdrückliche
          Zustimmung der CodeCamp:N nicht gestattet.
        </p>

        <h1 id="seventh">§ 7. Schlussbestimmungen</h1>

        <p>(1) Es gilt das Recht der
          Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
        </p>

        <p>(2) Sollten
          einzelne oder mehrere Bestimmungen ganz oder teilweise unwirksam sein oder
          werden, so wird hiervon die Gültigkeit der übrigen Bestimmungen nicht berührt.
          Gleiches gilt im Fall einer Regelungslücke. CodeCamp:N
          und Nutzer werden, sofern möglich, die unwirksame bzw. fehlende Klausel durch
          eine wirksame Klausel ersetzen, die dem Sinn und Zweck der unwirksamen bzw.
          fehlenden Klausel am nächsten kommt.
        </p>

        <p>(3) Gerichtsstand für
          sämtliche Streitigkeiten aus oder im Zusammenhang mit diesen AGB ist Nürnberg.
        </p>

        <p>(4) CodeCamp:N
          behält sich das Recht vor, diese AGB – soweit erforderlich – zu modifizieren
          und sie der technischen sowie rechtlichen Entwicklung anzupassen. Der Nutzer wird
          auf die Veränderung hingewiesen. Im Falle der Unwirksamkeit einzelner
          Regelungen dieser AGB bleibt die Wirksamkeit im Übrigen unberührt (vgl. § 8
          Abs. 2).
        </p>
      </b-col>
    </b-row>

  </div>
</template>

<script>
  import HeaderView from '@/components/common/HeaderView'

  export default {
    name: 'Terms',
    components: {
      HeaderView
    }
  }
</script>

<style scoped>
  a.ref {
    color: #67757c;
  }
</style>



// WEBPACK FOOTER //
// src/components/info/Terms.vue